<mat-sidenav-container class="container-123">

  <mat-sidenav #sidenav [(mode)]="over" [(opened)]="opened" class="bottom-to-top">
    <div  fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
      <!--<div class="with-bg"></div>
      <div>
        <a>
          <img class="circle" src="./assets/profile.png" width="100">
        </a>
      </div>-->
      <img style="width: 100%; height: auto !important;" src="./assets/office.png">
    </div>
    <div   class="py-3 text-white fondo-menu-lateral" fxLayout="column" fxLayoutAlign="center center"
      fxLayoutGap="7px">
      <div style="margin-left:10px;">
        <a >
          <span class="lead black-navi">{{usuario}}</span>
        </a>
      </div>
      <!--<div>
        <a>
          <span class="black-navi">usuario@networking.com</span>
        </a>
      </div>-->
    </div>

    <div class="mt-3">

      <mat-accordion multi="true" [displayMode]="displayMode" *ngIf="menuOptions.length>0">
        <span *ngFor="let item of menuOptions" >
          <mat-nav-list *ngIf="!item.haschildren">
            <a mat-list-item (click)="thisRoute(item);" routerLinkActive="active-link" [routerLink]="[item.ruta]" class="ml-2" style="font-size:15px;">
              <i class="material-icons">
                {{item.icono}}
              </i><span class="itemClass">{{item.opcion}}</span>
            </a>
          </mat-nav-list>
          <mat-expansion-panel *ngIf="item.haschildren" class="no-shadow">
              <mat-expansion-panel-header fxLayout="row" [expandedHeight]="expandHeight" [collapsedHeight]="collapseHeight">
                <mat-panel-title>
                  <i class="material-icons">
                      {{item.icono}}
                  </i><span class="itemClass">{{item.opcion}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list class="ml-0" dense>
                <mat-list-item *ngFor="let subItem of item.children" (click)="thisRoute(item);" [routerLink]="[subItem.ruta]">
                  <a routerLinkActive="active-link">
                    <i class="material-icons">
                      {{subItem.icono}}
                    </i><span class="itemChildClass">{{subItem.opcion}}</span>
                  </a>
                  <!-- <button mat-icon-button class="mr-3">
                      <mat-icon>info</mat-icon>
                    </button> -->
                </mat-list-item>
              </mat-nav-list>
            </mat-expansion-panel>
        </span>

      </mat-accordion>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="header-box-shadow">
      <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <button mat-button>
        <mat-icon class="mr-1">{{opcionActual.icon}}</mat-icon>
        {{opcionActual.opcion}}
      </button>
      <!--<span fxShow.lt-md="false" fxShow.gt-sm="true">
        <button mat-button>
          <mat-icon class="mr-1">link</mat-icon>
          Link</button>
        <button mat-button>
          <mat-icon class="mr-1">link</mat-icon>
          Link</button>
        <button mat-button [matMenuTriggerFor]="dropDown">
          DropDown
          <mat-icon class="ml-1">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #dropDown="matMenu" overlapTrigger="false">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Dropdown Link 1</span>
          </button>
          <button mat-menu-item disabled>
            <mat-icon>voicemail</mat-icon>
            <span>Dropdown Link 2</span>
          </button>
        </mat-menu>
      </span>-->
      <span class="spacer"></span>
      <button mat-button [matMenuTriggerFor]="menu" fxShow.lt-md="false" fxShow.gt-sm="true">
        <mat-icon>account_circle</mat-icon>
        <span class="ml-2">Cuenta</span>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu" fxShow.lt-md="true" fxShow.gt-sm="false">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu" overlapTrigger="false">
        <button mat-menu-item>
          <mat-icon>account_circle</mat-icon>
          <span>Mi Cuenta</span>
        </button>
        <button mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>Ajustes</span>
        </button>
        <!--<button mat-menu-item>
          <mat-icon>money</mat-icon>
          <span>Billing</span>
        </button>-->
      </mat-menu>
      <button mat-icon-button (click)="logOut()">
        <mat-icon class="ml-3" title="Logout">exit_to_app</mat-icon>
      </button>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>
